module.exports = __webpack_public_path__ + "media/images/me_with_scope-f313e27097ee17ca5cb76d27edb201de.png";